// Prefixed with "/" so the links also work from the subpages.
export const navLinks = [
  { label: 'Projekte', href: '/projekte' },
  { label: 'Leistungen', href: '/#services' },
  { label: 'Über mich', href: '/ueber-mich' },
  { label: 'FAQ', href: '/#faq' },
];
